import { Component, ChangeDetectionStrategy, input, signal, effect, inject, booleanAttribute, numberAttribute, computed } from '@angular/core';

import { string2Color } from '@models/utils/colors';
import { CacheService } from '@services/cache.service';
import { BaseMin } from '@base/base-min';

@Component({
    selector: 'vz-project-badge, [vz-project-badge]',
    template: `
        <span class="vz-project-badge"
            [style.background-color]="dispText() ? dispColor() : 'transparent'"
            [style.font-size.px]="size()"
            [title]="showTooltip() ? (tooltipPrefix() || '') + dispName() : ''">{{ dispText() }}</span>
        @if (showName()) {
            <span class="ml025">{{ dispName() }}</span>
        }
    `,
    styles: `
        @import 'theme';
        :host {
            white-space: nowrap;
            text-overflow: ellipsis;

            .vz-project-badge {
                padding: 2px 3px;
                border-radius: 4px;
                color: @textColorInv;
            }
        }
    `,
    host: {
        '[style.overflow]': 'overflow()'
    },
    changeDetection: ChangeDetectionStrategy.OnPush,
})

export class ProjectBadgeComponent extends BaseMin {
    guid          = input.required<string | undefined | null>();
    text          = input<string | undefined | null>();
    size          = input<number, unknown>(10, { transform: numberAttribute });
    tooltipPrefix = input<string | undefined | null>();
    showTooltip   = input<boolean, unknown>(true, { transform: booleanAttribute });
    collapse      = input<boolean, unknown>(true, { transform: booleanAttribute });
    showName      = input<boolean, unknown>(false, { transform: booleanAttribute });

    dispColor   = signal<string>('#888');
    dispText    = signal<string>('');
    dispName    = signal<string>('');
    overflow    = computed(() => this.collapse() ? 'hidden' : undefined);

    private readonly _cache     = inject(CacheService);

    constructor() {
        super();
        effect(() => {
            const pid = this.guid();
            const text = this.text();
            if (pid && text) {
                this.dispColor.set(string2Color(pid));
                this.dispText.set(text);
                this.dispName.set('');
            }
            else if (pid) {
                this.__U(['project']);
                this._S.project = this._cache.watch('project', pid).subscribe(st => {
                    if (st.item) {
                        this.dispColor.set(st.item._color);
                        this.dispName.set(st.item.name);
                        this.dispText.set(st.item.abbr);
                    }
                    // console.log('=[ProjectBadgeComponent]==> pid:', pid, 'project:', v);
                });
            }
        });
    }

}